import styled from "@xstyled/styled-components";

export const StyledHiddenInput = styled.input`
  position: absolute;
  opacity: 0;
  pointer-events: none;
`;
